import React from "react";
import "./Grid.scss";
import { dateToStr } from '../../coraWebComponents/utils/convert';
import { GridDetailRow } from "@progress/kendo-react-grid";
import _ from 'lodash';

export default function Detail({ detailSchema }) {
  return class extends GridDetailRow {
    render() {
      const media = window.matchMedia('only screen and (min-width: 768px)');

      return (
        <>
          {detailSchema &&
            detailSchema.map((d, i) => {
              const found = Object.entries(this.props.dataItem).find(
                (x) => x[0] === d.field
              );

              return found ? (
                <div className="row m-0" key={i}>
                  <div className={"col-" + (media.matches ? 2 : 4) + " p-0 gridDetailCol"}>
                    <p>
                      <strong>{d.title}: </strong>
                    </p>
                  </div>
                  <div className="col-8 p-0 gridDetailCol">
                    <p>{_.isDate(found[1]) ? dateToStr(found[1], "dd.MM.y") : found[1]}</p>
                  </div>
                  {media.matches && <div className="col-2 p-0 gridDetailCol" />}
                </div>
              ) : (
                <></>
              );
            })}
        </>
      );
    }
  };
}
